import { Transition, Dialog } from '@headlessui/react'
import { Achievement } from '../../lib/achievements'
import { useEffect, useState } from 'react'
import {
  XIcon
} from '@heroicons/react/outline'
import { Link } from 'react-router-dom'

type Props = {
  isOpen: boolean
  handleClose: () => void
  achievement: Achievement
}

export const AchievementModal = ({achievement, isOpen, handleClose}: Props) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isTransitionOpen, setIsTransitionOpen] = useState(false)

  useEffect(() => {
    if(!isOpen) {
      setIsTransitionOpen(false)
      return
    }

    setTimeout(() => {
      // workaround for animating on isOpen initial load
      // current={true} is broken for Transitions
      setIsTransitionOpen(isOpen)
    }, 10)

    setTimeout(() => {
      setIsLoaded(true)
    }, 2000)
  }, [isOpen])

  const onClose = () => {
    if(!isLoaded) {
      return
    }
    handleClose()
  }

  return ( 
  <Transition show={isTransitionOpen}>
  <Dialog className="relative z-30" onClose={onClose}>
  <Transition.Child
      className="fixed inset-0"
      aria-hidden="true"
      enter="transition-all duration-[2000ms]"
      enterFrom="bg-transparent"
      enterTo="dark:bg-slate-900 bg-slate-100 opacity-[.98]"
      leave="duration-0"
      leaveFrom=""
      leaveTo="">
  </Transition.Child>
  <div className={`fixed z-30 inset-0 flex items-center justify-center
    ${isLoaded ? '' : 'pointer-events-none'}`} onClick={onClose}>
    <Dialog.Panel className="mx-auto">
    <Transition.Child className="w-full h-full">
        <Transition.Child
          className="flex flex-col items-center justify-center dark:text-white border pb-4 rounded-xl"
          enter="transition-all duration-[2000ms]"
          enterFrom="border-transparent"
          enterTo="border-slate-300 dark:border-slate-700"
          leave="duration-0"
          leaveFrom=""
          leaveTo="">
          <Transition.Child className="w-full"
          enter="transition-all duration-[2000ms] ease-in"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="duration-0"
          leaveFrom=""
          leaveTo="">
          <XIcon
            className="flex ml-auto p-2 h-10 w-10 scale-up cursor-pointer dark:stroke-white"
            aria-label="close-menu"
            role="button"
            tabIndex={0}
            onClick={onClose}
          />
        </Transition.Child>
      <Transition.Child
        className="title text-gray-600 dark:text-gray-400"
        enter="transition-all duration-[2000ms]"
        enterFrom="scale-0"
        enterTo="scale-100"
        leave="duration-0"
        leaveFrom=""
        leaveTo="">
        New Achievement
      </Transition.Child>
      <Transition.Child
        className="text-4xl m-2 title px-8"
        enter="transition-[transform,opacity] transform duration-[2000ms]"
        enterFrom="-translate-x-72 opacity-0"
        enterTo="translate-x-0 opacity-100"
        leave="duration-0"
        leaveFrom=""
        leaveTo="">
        {achievement.getTitle()}
      </Transition.Child>
      <Transition.Child
        className="achievement mx-8"
        enter="enter"
        enterFrom="enterFrom"
        enterTo="enterTo"
        leave=""
        leaveFrom=""
        leaveTo="">
          <img className={achievement.getStyle()} src={achievement.getImg()} alt={achievement.getTitle()}/>
      </Transition.Child>
      <Transition.Child
        className="m-2 title"
        enter="transition-[transform,opacity] transform duration-[2000ms]"
        enterFrom="translate-x-72 opacity-0"
        enterTo="translate-x-0 opacity-100"
        leave="duration-0"
        leaveFrom=""
        leaveTo="">
        {isLoaded}
        {achievement.getDescription()}
      </Transition.Child>
      <Transition.Child
      enter="transition-all duration-[2000ms] ease-in"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="duration-0"
      leaveFrom=""
      leaveTo="">
      <Link to="/achievements" className="text-xs title mt-4 text-indigo-700 dark:text-indigo-400 font-bold hover:dark:text-indigo-600 hover:text-indigo-800" >
        View your achievements
      </Link>
      </Transition.Child>
    </Transition.Child>
    </Transition.Child>
    </Dialog.Panel>
  </div>
  </Dialog>
  </Transition>
    )
}
